/*
 * File: src/components/PageHeader.tsx
 * Notes:
 *   > ...
 */

import React, { FunctionComponent } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core";

const useStyles = makeStyles<Theme, PageHeaderProps>((theme) => ({
  hero: {
    paddingTop: "8rem",
    [theme.breakpoints.up("lg")]: {
      height: 350,
    },
    transition: "background-color .75s",
    backgroundColor: (props) => {
      return theme.palette[props.color || "primary"].dark;
    },
  },
  container: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
  title: {
    color: theme.palette.primary.contrastText,
  },
}));

export interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  color?: "success" | "error" | "primary" | "secondary";
}

const PageHeader: FunctionComponent<PageHeaderProps> = (props) => {
  const classes = useStyles(props);

  return (
    <section className={`block-hero hero hero-post-6 ${classes.hero}`}>
      <div className="container">
        <div className="row align-items-center ">
          <div className="col-lg-6">
            {/* <nav className="breadcrumb-wrapper" aria-label="breadcrumb">
                            <ol className="breadcrumb row" typeof="BreadcrumbList" vocab="https://schema.org/">
                                <li className="breadcrumb-item">
                                    <span property="name">{subtitle}</span>
                                </li>
                            </ol>
                        </nav> */}

            <h1>{props.title}</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
